<!-- Persoana fizica -->
<div class="g-0">
    <div class="row">
        <div class="col-sm-12 col-md-6">
            <div class="box-wrapper box-info" style="border: 2px solid #6495ad !important">
                <div class="box-content-header" style="background: #6495ad">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-regular fa-user"></i>
                                <span>Subsemnatul</span>
                            </mat-card-title>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onSubsemnatulInfoChange($event)" value="info">
                                    <mat-button-toggle value="info">Info</mat-button-toggle>
                                    <mat-button-toggle value="adresa">Adresă</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere?.beneficiar"
                                        value="beneficiar">Beneficiar</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed table-wrapper-box" *ngIf="selectedSubsemnatulStatus === 'info'">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Nume</strong>
                                </td>
                                <td class="text-left">{{ cerere?.cetatean?.nume }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Prenume</strong>
                                </td>
                                <td class="text-left">{{ cerere?.cetatean?.prenume }}</td>
                            </tr>
                            <tr *ngIf="cerere?.cetatean?.cnp">
                                <!-- Check if cnp is not null -->

                                <td class="text-center">
                                    <strong>CNP</strong>
                                </td>
                                <td class="text-left">{{ cerere?.cetatean?.cnp }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>CI</strong>
                                </td>
                                <td class="text-left">{{ (cerere?.cetatean?.ci_serie | uppercase) + ' - ' +
                                    cerere?.cetatean?.ci_numar }} </td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Email</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.cetatean?.email }}
                                    <span style="cursor: pointer;" *ngIf="cerere?.subsemnat_id === null" class="text-warning pointer" (click)="updateInformatiiCerere('email', 1)"><i
                                            class="fa fa-pencil"></i></span>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong>Telefon</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.cetatean?.telefon }}
                                    <span style="cursor: pointer;" *ngIf="cerere?.subsemnat_id === null" class="text-warning pointer" (click)="updateInformatiiCerere('telefon', 1)"><i
                                            class="fa fa-pencil"></i></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-condensed table-wrapper-box"
                        *ngIf="selectedSubsemnatulStatus === 'adresa'">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Județ:</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.homeAddress?.judet || 'N/A' }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Oraș:</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.homeAddress?.oras || 'N/A' }}
                                </td>
                            </tr>
                            <tr *ngIf="cerere?.homeAddress?.sector && cerere?.homeAddress?.sector !== '-1'">
                                <td width="40%" class="text-center">
                                    <strong>Sector:</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.homeAddress?.sector }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Adresă:</strong>
                                </td>
                                <td class="text-left">
                                    {{
                                    'str. ' + (cerere?.homeAddress?.strada || '-') +
                                    ', nr. ' + (cerere?.homeAddress?.numar || '-') +
                                    ', bl. ' + (cerere?.homeAddress?.bloc || '-') +
                                    ', sc. ' + (cerere?.homeAddress?.scara || '-') +
                                    ', et. ' + (cerere?.homeAddress?.etaj || '-') +
                                    ', ap. ' + (cerere?.homeAddress?.apartament || '-')
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Obs:</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.homeAddress?.observatii || 'N/A' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="col d-flex justify-content-start p-2"
                        *ngIf="selectedSubsemnatulStatus === 'beneficiar'">
                        <div>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onBeneficiarInfoChange($event)" value="info">
                                <mat-button-toggle value="info">Info</mat-button-toggle>
                                <mat-button-toggle value="adresa">Adresă</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                    <table class="table table-condensed table-wrapper-box" *ngIf="
                              selectedSubsemnatulStatus === 'beneficiar' &&
                              selectedBeneficiaryInfoStatus === 'info'
                            ">
                        <tbody>
                            <!-- beneficiar PF -->
                            <ng-container *ngIf="cerere?.beneficiar?.beneficiar_type === '1'">
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Nume</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.beneficiar?.nume }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Prenume</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.beneficiar?.prenume }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>CNP</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.beneficiar?.cnp_cui }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>CI Serie</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.beneficiar?.ci_serie }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>CI Număr</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.beneficiar?.ci_numar }}</td>
                                </tr>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>CI Emitent</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ cerere?.beneficiar?.ci_emitent }}
                                    </td>
                                </tr>
                            </ng-container>
                            <!-- beneficiar PJ -->
                            <ng-container *ngIf="cerere?.beneficiar?.beneficiar_type === '2'">
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong>Denumire companie</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.beneficiar?.denumire }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>CUI/CIF</strong>
                                    </td>
                                    <td class="text-left">{{ cerere?.beneficiar?.cnp_cui }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong>Registrul comerțului</strong>
                                    </td>
                                    <td class="text-left">
                                        {{ cerere?.beneficiar?.reg_com || "n/a" }}
                                    </td>
                                </tr>
                            </ng-container>

                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Activ</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.active == 1 ? "Da" : "Nu" }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Creat la</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.created_at | date }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Expiră la</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.expiry_date | date }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Validat</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.validated_date ? "Da" : "Nu" }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-condensed table-wrapper-box" *ngIf="
                              selectedSubsemnatulStatus === 'beneficiar' &&
                              selectedBeneficiaryInfoStatus === 'adresa'
                            ">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Județ</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].judet_name }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Oraș</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].oras }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Strada</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].strada }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Număr</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].numar }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Bloc</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].bloc }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Scara</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].scara }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Etaj</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].etaj }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Apartament</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.beneficiar?.addresses[0].apartament }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="box-wrapper box-property" style="border: 2px solid #e06c7a">
                <div class="box-content-header" style="background-color: #e06c7a">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-location-crosshairs"></i>
                                <span>Firmă/Societate</span>
                            </mat-card-title>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onFirmaInfoChange($event)" value="info">
                                    <mat-button-toggle value="info">Info</mat-button-toggle>
                                    <mat-button-toggle value="adresa">Sediu</mat-button-toggle>
                                    <mat-button-toggle *ngIf="hasPunctLucru" value="punctLucru">Punct
                                        Lucru</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table *ngIf="selectedFirmaInfoStatus === 'info'" class="table table-condensed table-wrapper-box">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Firmă/Societate</strong>
                                </td>
                                <td class="text-left">
                                    {{
                                    cerere?.persoana_juridica?.f_nume ? cerere?.persoana_juridica?.f_nume : "N/A"
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>CUI</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.persoana_juridica?.f_cui ? cerere?.persoana_juridica?.f_cui : "N/A" }}
                                    <span style="cursor: pointer;" *ngIf="cerere?.subsemnat_id === null" class="text-warning pointer" (click)="updateInformatiiCerere('f_cui', 2)"><i
                                            class="fa fa-pencil"></i></span>
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>REG COM</strong>
                                </td>
                                <td class="text-left">
                                    {{
                                    cerere?.persoana_juridica?.f_reg_com
                                    ? cerere?.persoana_juridica?.f_reg_com
                                    : "N/A"
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Tip Reprezentant</strong>
                                </td>
                                <td class="text-left">
                                    {{ mapTipReprezentant(cerere?.persoana_juridica?.f_reprezentant) }}
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="selectedBeneficiaryInfoStatus === 'adresa'"></tbody>
                    </table>
                    <table *ngIf="selectedFirmaInfoStatus === 'adresa'" class="table table-condensed table-wrapper-box">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Județ:</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.sediu?.judet || 'N/A' }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Oraș:</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.sediu?.oras || 'N/A' }}
                                </td>
                            </tr>
                            <tr *ngIf="cerere?.sediu?.sector && cerere?.sediu?.sector !== '-1'">
                                <td width="40%" class="text-center">
                                    <strong>Sector:</strong>
                                </td>
                                <td class="text-left">
                                    {{ cerere?.sediu?.sector }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Adresă:</strong>
                                </td>
                                <td class="text-left">
                                    {{
                                    'str. ' + (this.cerere?.sediu?.strada || '-') +
                                    ', nr. ' + (this.cerere?.sediu?.numar || '-') +
                                    ', bl. ' + (this.cerere?.sediu?.bloc || '-') +
                                    ', sc. ' + (this.cerere?.sediu?.scara || '-') +
                                    ', et. ' + (this.cerere?.sediu?.etaj || '-') +
                                    ', ap. ' + (this.cerere?.sediu?.apartament || '-')
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Obs.</strong>
                                </td>
                                <td class="text-left">{{ cerere?.sediu?.observatii
                                    ? cerere?.sediu?.observatii
                                    : "N/A" }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table *ngIf="selectedFirmaInfoStatus === 'punctLucru' && hasPunctLucru"
                        class="table table-condensed table-wrapper-box">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Adresa</strong>
                                </td>
                                <td class="text-left">
                                    {{
                                    'str. ' + (this.cerere?.punct_lucru?.strada || '-') +
                                    ', nr. ' + (this.cerere?.punct_lucru?.numar || '-') +
                                    ', bl. ' + (this.cerere?.punct_lucru?.bloc || '-') +
                                    ', sc. ' + (this.cerere?.punct_lucru?.scara || '-') +
                                    ', et. ' + (this.cerere?.punct_lucru?.etaj || '-') +
                                    ', ap. ' + (this.cerere?.punct_lucru?.apartament || '-')
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong>Obs.</strong>
                                </td>
                                <td class="text-left">
                                    {{
                                    this.cerere?.punct_lucru?.observatii
                                    ? this.cerere?.punct_lucru?.observatii
                                    : "N/A"
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>